<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

        <div class="nav_027_wraper">
          <div
            class="nav_ele_027_one_wraper"
            :class="timeType === 1 ? 'nav_ele_027_one_wraper_active' : ''"
            @click="navOneEleBtnHandle(1)"
          >日</div>
          <div
            class="nav_ele_027_one_wraper"
            :class="timeType === 2 ? 'nav_ele_027_one_wraper_active' : ''"
            @click="navOneEleBtnHandle(2)"
          >周</div>
          <div
            class="nav_ele_027_one_wraper"
            :class="timeType === 3 ? 'nav_ele_027_one_wraper_active' : ''"
            @click="navOneEleBtnHandle(3)"
          >月</div>
          <div
            class="nav_ele_027_one_wraper"
            :class="timeType === 4 ? 'nav_ele_027_one_wraper_active' : ''"
            @click="navOneEleBtnHandle(4)"
          >年</div>
        </div>

        <div class="eChartsMain_wraper">
          <div class="nav_027_page_control_wraper">
            <img
              v-show="computerLastImgShow"
              @click="PageTurningBtnHandle(-1)"
              src="~assets/img/config/zuojiantoulan.png"
              alt
            />
            <img
              @click="$toast('没有更多了~')"
              v-show="!computerLastImgShow"
              src="~assets/img/config/zuojiantouhui.png"
              alt
            />

            <div class="nav_027_page_control_title_date">
              <div>{{ currentTime }}</div>
              <!-- ///显示年份，只有日和周需要显示 -->
              <!-- <div
                v-show="timeType === 1 || timeType === 2"
                class="nav_027_page_currentYearTime"
              >
                （{{ currentYearTime }}年）
              </div>-->
            </div>
            <img
              v-show="computerNextImgShow"
              @click="PageTurningBtnHandle(1)"
              src="~assets/img/config/youjiantoulan.png"
              alt
            />
            <img
              @click="$toast('没有更多了~')"
              v-show="!computerNextImgShow"
              src="~assets/img/config/youjiantouhui.png"
              alt
            />
          </div>
          <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
          <div id="eChartsMain" style="width: 100%;height:400px;"></div>
        </div>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang>
          <span slot="config_hang_ele2">用电总量</span>
          <span slot="config_hang_ele3">{{ bar.sumElectric }}</span>
        </config-hang>

        <!-- <config-title-hang>
          <span slot="config_title_hang_ele2">用电明细</span>
        </config-title-hang>-->
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang>
          <span slot="config_hang_ele2">用电明细</span>
        </config-hang>

        <config-hang v-for="(value, index) in serveListData" :key="index">
          <span class="page027_config_hang_ele2" slot="config_hang_ele2">{{ value.time }}</span>
          <span slot="config_hang_ele3">{{ value.electric }}</span>
        </config-hang>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";

import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";

export default {
  data() {
    return {
      xuint: "", //X轴单位
      timeType: 1, // 时间类型 1:日 2:周 3:月 4:年
      pageSize: 8, // 每页显示条数
      currentPage: 1, //当前页数
      currentTime: "", ////D当前柱状图展示的时间
      // currentYearTime: '', ////当前柱状图展示的年份
      bar: {
        ////服务器返回的柱状图数据
        xdata: [
          ////服务器返回的X轴展示数据
        ],
        seriesData: [
          ////服务器返回的Y轴展示值
        ],
        sumElectric: "" ////服务器返回的用电总量
      },
      serveListData: [
        ////服务器返回的列表数据
        {
          electric: "0.9970kw.h",
          time: "1.13-1.19"
        },
        {
          electric: "0.0000kw.h",
          time: "1.20-1.26"
        },
        {
          electric: "0.0000kw.h",
          time: "1.27-2.2"
        }
      ]
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  computed: {
    computerNextImgShow() {
      ////计算下一页的按钮是否显示
      let dataLength = this.serveListData.length;
      console.log(dataLength);
      if (dataLength === 0) {
        ////s说明当前一条数据都没有
        return false;
      }
      if (
        this.currentTime === this.serveListData[0].time
        // &&
        // this.currentYearTime === this.serveListData[0].yearTime
      ) {
        return false;
      } else {
        return true;
      }
    },
    computerLastImgShow() {
      ////计算上一页的按钮是否显示
      let dataLength = this.serveListData.length;
      console.log(dataLength);
      if (dataLength === 0) {
        ////s说明当前一条数据都没有
        return false;
      }
      if (
        this.currentTime === this.serveListData[dataLength - 1].time
        // &&
        // this.currentYearTime === this.serveListData[dataLength - 1].yearTime
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    drawChart() {
      /////柱状图
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("eChartsMain"));
      // 指定图表的配置项和数据 (月)
      let monthOption = {
        // title: {
        //   text: 'ECharts 入门示例'
        // },
        tooltip: {
          ////悬浮提示框内容
          formatter:
            "{a}" + "<br />" + "{b0}" + this.xuint + ":" + "{c0}" + "度"
        },
        legend: {
          data: ["销量"]
        },
        xAxis: {
          name: this.xuint,
          data: this.bar.xdata,
          axisLine: {
            lineStyle: {
              ////X坐标线的颜色
              width: "2",
              color: "#DDDDDD"
            },
            splitLine: {
              ////分割线
              show: true
            }
          }
        },
        yAxis: {
          name: "kw.h",

          axisLine: {
            lineStyle: {
              ////Y坐标线的颜色

              width: "2",
              color: "#DDDDDD"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#f5f5f5"
            }
          }
        },
        series: [
          {
            name: "电量",
            type: "bar",
            data: this.bar.seriesData,

            legendHoverLink: true, ///是否启用图例 hover 时的联动高亮。
            itemStyle: {
              ////图形的颜色
              color: "#44b4fd"
            }
          }
        ],
        textStyle: {
          /////文字的颜色
          color: "#999999"
        }
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(monthOption);
    },
    navOneEleBtnHandle(data) {
      ///电量类型
      this.timeType = data;

      this.psotServeData1List(this.timeType, this.pageSize, 1); ////3是条目数，1是页数
    },
    psotServeData1List(timeType, pageSize, currentPage) {
      // 获取当前插座电量统计明细列表
      this.$request({
        method: "post",
        url: "/device/findHistoricalElectricityList",
        data: {
          token: this.$store.state.token,
          deviceId: this.$route.query.deviceId,
          timeType: timeType, //时间类型 1:日 2:周 3:月 4:年
          pageSize: pageSize, ///每页显示条数
          currentPage: currentPage ///当前页数
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serveListData = res.data.data; ////拿到服务器返回的数据结果
            console.log(this.serveListData);

            let serveListDataLength = this.serveListData.length;
            if (serveListDataLength === 0) {
              ////说明没有数据，不取数据显示
              this.$toast("暂时没有数据！", 3000);
              return;
            } else if (serveListDataLength === 1) {
              ///说明只有1条数据  取今天的数据显示
              this.currentTime = this.serveListData[0].time; ////1拿的是昨天或上一周
              // this.currentYearTime = this.serveListData[0].yearTime
            } else {
              ///说明数据正常超过1条了，取昨天的数据显示
              this.currentTime = this.serveListData[1].time; ////1拿的是昨天或上一周
              // this.currentYearTime = this.serveListData[1].yearTime
            }

            ///修改显示单位
            if (this.timeType === 1) {
              this.xuint = "时";
            } else if (this.timeType === 2) {
              this.xuint = "天";
            } else if (this.timeType === 3) {
              this.xuint = "日";
            } else if (this.timeType === 4) {
              this.xuint = "月";
            }

            this.postServeData2(this.timeType, this.currentTime); ////请求柱状图渲染数据
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    postServeData2(timeType, time) {
      // 获取当前插座电量统计
      this.$request({
        method: "post",
        url: "/device/findHistoricalElectricity",
        data: {
          token: this.$store.state.token,
          deviceId: this.$route.query.deviceId,
          timeType: timeType, //时间类型 1:日 2:周 3:月 4:年
          time: time ///时间
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
      // let xdata = [
      // ////字符串格式  24小时   （周，月，年的返下面deUI图） 
      //       "0",
      //       "1",
      //       "2",
      //       "3",
      //       "4",
      //       "5",
      //       "6",
      //       "7",
      //       "8",
      //       "9",
      //       "10",
      //       "11",
      //       "12",
      //       "13",
      //       "14",
      //       "15",
      //       "16",
      //       "17",
      //       "18",
      //       "19",
      //       "20",
      //       "21",
      //       "22",
      //       "23"
      // ]
      // let seriesData = [
      // /////对应每个小时的电量  数字格式（或者每天，每周,每年）
      //       "0.08",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "0",
      //       "8.005",
      //       "4"
 
      // ]

            // this.bar.xdata = xdata; ////拿到柱状图的渲染数据
            // this.bar.seriesData = seriesData;
            this.bar.xdata = res.data.data.xList ////拿到柱状图的渲染数据
            this.bar.seriesData = res.data.data.yList
            this.bar.sumElectric = res.data.data.sumElectric;
            // this.myChart.setOption(this.monthOption)
            this.drawChart(); ///刷新柱状图
            // this.serveListData = res.data.data ////拿到服务器返回的数据结果
            // this.currentTime = this.serveListData[0].time
            // console.log(this.serveListData)
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    PageTurningBtnHandle(pageType) {
      console.log("历史电量的上一页和下一页按钮点击了");
      if (pageType === -1) {
        ///上一页
        for (let i = 0; i < this.serveListData.length; i++) {
          if (this.currentTime === this.serveListData[i].time) {
            this.currentTime = this.serveListData[i + 1].time;
            // this.currentYearTime = this.serveListData[i + 1].yearTime

            this.postServeData2(this.timeType, this.currentTime); ////请求柱状图渲染数据

            break; ////退出FOR循环
          }
        }
      } else if (pageType === 1) {
        ///下一页
        for (let i = 0; i < this.serveListData.length; i++) {
          if (this.currentTime === this.serveListData[i].time) {
            this.currentTime = this.serveListData[i - 1].time;

            this.postServeData2(this.timeType, this.currentTime); ////请求柱状图渲染数据

            break; ////退出FOR循环
          }
        }
      }
    }
  },

  mounted() {
    console.log("mounted阶段");
    this.$nextTick(() => {
      ////绘制柱状图
      this.drawChart();
    });
  },
  created() {
    this.$nextTick(() => {
      ////请求日类型数据列表，默认刚进去显示日类型
      this.navOneEleBtnHandle(1);
    });
    // console.log("created阶段");
    // console.log(this.query.title);
    /// 获取产品详情接口，获取数据
    // this.$request({
    //   method: 'post',
    //   url: '/product/findProductById',
    //   data: {
    //     token: this.$store.state.token,
    //     productId: this.$route.query.productId
    //   }
    // })
    //   .then(res => {
    //     if (res.data.code != 0) {
    //       this.$showTipsToast(3, res.data.message)
    //       ////说明信息填写错误,控制失败了，
    //       return
    //     } else {
    //       ////、控制成功了
    //       this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果
    //       console.log(this.serveDeviceDetailsData)
    //       // this.$showTipsToast(1, "获取成功", true); ////提示框
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  }
};
</script>

<style>
.nav_027_wraper {
  /* width: 80%; */
  display: flex;
  justify-content: space-around;
  align-items: center;

  font-size: 18px;

  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 5px;

  cursor: pointer;
  margin: 20px 20px;
}
.nav_ele_027_one_wraper {
  height: 40px;
  /* border: 1px solid var(--primary-color); */
  flex: 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-right: 1px solid var(--primary-color);
}
.nav_ele_027_one_wraper:last-of-type {
  border-right: none;
}
/* .nav_ele_027_one_wraper_fengexiao {
  border-right: 1px solid var(--primary-color);
} */

.eChartsMain_wraper {
  display: inline-block;
  position: relative;
  width: 100%;
}
.nav_027_page_control_wraper {
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 18px;
  color: #999999;

  margin-top: 20px;
}
.nav_027_page_control_wraper > img {
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.nav_027_page_control_wraper > div {
  margin: 0px 18px;
  min-width: 100px;
}
.page027_config_hang_ele2 {
  color: #999999;
}
.nav_ele_027_one_wraper_active {
  background-color: var(--primary-color);
  color: #ffffff;
}
.nav_027_page_control_title_date {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.nav_027_page_currentYearTime {
  font-size: 14px;
}
</style>
